import 'bootstrap/js/modal';

const dialogTemplate = '<div class="modal show-dialog fade"><div class="modal-dialog"><div class="modal-content"><div class="modal-header"><h4 class="dialog-title"></h4></div><div class="modal-body"></div><div class="modal-footer"></div></div></div></div>';

module.exports = function(title, content, callbacks, buttons, options) {
	var $dialog = $(dialogTemplate);
	$dialog.find('.dialog-title').html(title);
	$dialog.find('.modal-body').html(content);
	options = options || {};

	if (options.contentClasses) {
		$dialog.find('.modal-content').addClass(options.contentClasses);
	}

	if (options.closeButton === true) {
		$dialog.find('.modal-header').prepend('<button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>');
	}

	var buttonDefaults = {
		classes: "btn btn-default",
		text: "Ok",
		attr: {
			"data-dismiss": "modal"
		}
	};

	buttons = buttons || [];

	buttons.reverse();
	$.each(buttons, function(index, button){
		var btnOpts = $.extend(true, {}, buttonDefaults, button);

		var $button = $("<button></button");

		$button.addClass(btnOpts.classes);

		$.each(btnOpts.attr, function(key, value){
			$button.attr(key, value);
		});

		$button.html(btnOpts.text);

		if (typeof btnOpts.callback === 'function') {
			$button.on('click', function(){ btnOpts.callback($dialog); })
		}

		$dialog.find('.modal-footer').append($button);
	});

	$('body').append($dialog);

	if (typeof callbacks === 'function') {
		callbacks = {'shown.bs.modal': callbacks};
	}

	if (typeof callbacks === 'object') {
		for (var key in callbacks) {
			$dialog.on(key, callbacks[key]);
		}
	}

	var dialog = $('.show-dialog')
					.removeClass('.show-dialog')
					.modal();

	$(document).keyup(function(e) {
		if(e.which == 27) {
			dialog.modal('hide');
		}
	});

	dialog.on('hidden.bs.modal', function (event) {
		$(event.target).remove();
	});

	$dialog.setContent = function(content) {
		$dialog.find('.modal-body').html(content);
	};

	$dialog.setTitle = function(title) {
		$dialog.find('.dialog-title').html(title);
	};

	return $dialog;
};
